module.exports = "/_next/static/images/cardImage1-2de2c6537c03276e6e8360eaab2d1cf2.webp";